import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  unReadNotificationCount: 0,
};

const commonSlice = createSlice({
  name: "commonSlice",
  initialState,
  //   reducer needs a map
  reducers: {
    setUnReadNotificationCount(state, action) {
      state.unReadNotificationCount = action.payload;
    },
    removeUnReadNotification(state, action) {
      state.unReadNotificationCount = state.unReadNotificationCount - 1;
    },
  },
});

export const { setUnReadNotificationCount, removeUnReadNotification } =
  commonSlice.actions;

export default commonSlice.reducer;
